import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Events } from './components/Events';
import { Spaces } from './components/Spaces';
import { Branches } from './components/Branches';
import { Gallery } from './components/Gallery';
import { Reviews } from './components/Reviews';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="min-h-screen bg-matambrito-black selection:bg-matambrito-red-fire selection:text-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Services data-id="element-5" />
        <Events data-id="element-6" />
        <Spaces data-id="element-7" />
        <Branches data-id="element-8" />
        <Gallery data-id="element-9" />
        <Reviews data-id="element-10" />
        <Contact data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
      <WhatsAppButton data-id="element-13" />
    </div>;
}